module.exports = __webpack_public_path__ + "img/document-disabled.e1c4f5b2.svg";